import axios from '../../plugins/axios'

export const actions = {
    listarFazendasPorAno(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('fazendas/listar-fazendas-ano' + payload,)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    listarFazendas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`fazendas` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    atualizarFazenda(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put(`fazendas/${payload.id}`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })

        })
    },
    obterFazendasCms(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`fazendas/${payload.fazenda_id}/fazenda`,)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })

        })
    },
    listarConsorcio(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`balanco-energetico/consorcios/listar`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })

        })
    },
    uploadFazendas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('fazendas/payload', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    processarFazendas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('fazendas/processar-payload', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/fazenda.js